// Cross-platform merge acknowledgement (IM-999): the "Confirm & Merge" button on
// the merge review panel stays disabled until the agent ticks the checkbox.
// The server enforces the same gate — this only keeps the button honest.
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["acknowledge", "submit"]

  connect() {
    this.toggle()
  }

  toggle() {
    this.submitTarget.disabled = !this.acknowledgeTarget.checked
  }
}
